import { render, staticRenderFns } from "./productdetails.vue?vue&type=template&id=55b7446d&scoped=true"
import script from "./productdetails.vue?vue&type=script&lang=js"
export * from "./productdetails.vue?vue&type=script&lang=js"
import style0 from "./productdetails.vue?vue&type=style&index=0&id=55b7446d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b7446d",
  null
  
)

export default component.exports